import { Col, Form, Row, Select } from "antd";
import type React from "react";

const { Option } = Select;

interface MemberChatStatusFilterProps {
	className?: string;
}

export const MemberChatStatusFilter: React.FC<MemberChatStatusFilterProps> = ({
	className = "mb-4",
}) => {
	return (
		<Row gutter={[16, 16]} justify="start">
			<Col xs={{ span: 24 }}>
				<Form.Item name="messages" className={className}>
					<Select placeholder="未読／既読" allowClear>
						<Option value="unread">未読</Option>
						<Option value="read">既読</Option>
					</Select>
				</Form.Item>
			</Col>
		</Row>
	);
};
